const pageActionArea = (theme) => ({
  page: {
    flexDirection: 'column',
    width: '100%',
    alignContent: 'stretch',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      minHeight: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`
    }
  },
  pageLoader: {
    zIndex: theme.zIndex.modal
  },
  pageHeader: {
    width: '100%',
    marginBottom: 50,
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    justifyContent: 'center',

    [theme.breakpoints.down('md')]: {
      marginBottom: 50,

      h1: {
        fontSize: '1.6em',
        lineHeight: '1.6em',
        marginBottom: 10
      },

      '.MuiTypography-subtitle1': {
        lineHeight: '1.3em'
      }
    }
  },

  backButtonBox: {
    position: 'relative',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      display: 'none'
    },

    '.backButton': {
      position: 'absolute',
      // Match the mt of the H1
      top: 31,
      left: -2
    }
  },

  contentArea: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '100%',
    // alignItems: 'center',
    // justifyContent: 'center',
    // alignContent: 'center',
    // width: '100%',

    [theme.breakpoints.down('md')]: {
      flexGrow: 1,
      justifyContent: 'center'
    }
  },

  content: {
    margin: '0 auto',
    width: '100%',
    height: '100%',
    flexGrow: 1,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
      // display: 'flex',
      alignContent: 'center',
      width: '100%'

    }
  },

  actionArea: {
    marginTop: 20,
    // gap: '0 10px',
    display: 'flex',

    '.nextButton': {
      paddingRight: 35,
      paddingLeft: 35
    },

    [theme.breakpoints.down('md')]: {
      justifyContent: 'center',
      position: 'fixed',
      bottom: 0,
      left: 0,
      width: '100%',
      background: '#FFF',
      flexDirection: 'column-reverse',
      padding: 10,
      borderTop: `1px solid ${theme.palette.grey.superLight}`,

      'a, button': {
        width: '100%'
      },

      '.backButton': {
        position: 'fixed',
        left: 20,
        top: 30
      },

      '.skipButton': {
        display: 'none'
      }
    }
  },

  dummyActionArea: {
    height: theme.mixins.toolbar.minHeight + 15
  }
});

export default pageActionArea;
